/**
 * Hand-rolled "5 minutes ago" / "2 days ago" formatter using the platform's
 * `Intl.RelativeTimeFormat`. Avoids pulling in `date-fns` for a single
 * helper. Beyond a week, falls back to an absolute locale-formatted date so
 * "37 weeks ago" doesn't get printed.
 */
const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

export const formatRelativeTime = (iso: string | null | undefined): string => {
  if (!iso) return '';
  const target = new Date(iso).getTime();
  if (Number.isNaN(target)) return '';

  const diffMs = target - Date.now();
  const absMs = Math.abs(diffMs);
  const minute = 60_000;
  const hour = 60 * minute;
  const day = 24 * hour;

  if (absMs < hour) {
    return rtf.format(Math.round(diffMs / minute), 'minute');
  }
  if (absMs < day) {
    return rtf.format(Math.round(diffMs / hour), 'hour');
  }
  if (absMs < 7 * day) {
    return rtf.format(Math.round(diffMs / day), 'day');
  }

  return new Date(iso).toLocaleDateString();
};
